<template>
  <div class="row" style="height: 500px; width: 100%">
    <div class="waiting_div" v-show="waiting">
      <Spinner size="medium" :message="waiting_msg"></Spinner>
    </div>

    <div id="nav_options" class="col-sm-3">
      <div>
        <img :src="require('@/assets/salogo2.png')" />
        <a target="_blank" href="http://www.cr2.cl/datos-dendro-sada/"
          ><b
            ><h3 style="text-align: center; font-size: 16px; font-weight: bold">
              ACERCA DEL ATLAS
            </h3></b
          ></a
        >
      </div>
      <hr />

      <div class="row" style="margin-left: 1px">
        <h3 class="title_nav">Mapas</h3>

        <button
          @click="$vm2.open('modal-1')"
          class="button_as_link"
          style="width: 40px; margin-left: 10px; margin-bottom: 2px"
          title=""
        >
          <v-icon
            style="width: 25px; margin-bottom: 4px"
            name="help-circle"
          ></v-icon>
        </button>
        <vue-modal-2
          name="modal-1"
          @on-close="$vm2.close('modal-1')"
          :noFooter="true"
          :headerOptions="{ title: 'Ayuda' }"
        >
          Permite calcular mapas de la condición de sequía para:
          <ul>
            <li>(i) años individuales</li>
            <li>(ii) promedio de años</li>
            <li>
              (iii) mapas de correlación entre el Atlas de sequía y una serie de
              tiempo que ingrese el usuario.
            </li>
          </ul>
        </vue-modal-2>
      </div>

      <table style="table-layout: fixed; width: 100%; text-align: left">
        <tr>
          <td style="width: 50%">
            <p>Años:</p>
          </td>
          <td style="width: 50%">
            <div>
              <div>
                <select
                  @change="onChangeRaster()"
                  class="custom-select"
                  v-model="active_raster"
                  name="raster_activo"
                >
                  <option
                    v-for="(val, key) in available_datasets['SADA']
                      ? available_datasets['SADA']['raster_data']['order_keys']
                      : []"
                    :key="key"
                  >
                    {{ val.raster_key }}
                  </option>
                </select>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div>
        <table style="table-layout: fixed; width: 100%">
          <tr>
            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                style="width: 100%"
                @click="showMeanModal = true"
              >
                Promedio de años
              </button>
              <ModalMeanSADA
                v-if="showMeanModal"
                :waiting.sync="waiting"
                :waiting_msg.sync="waiting_msg"
                :current_map_special_name.sync="current_map_special_name"
                v-bind:options="
                  this.available_datasets['SADA']['raster_data'][
                    'order_keys'
                  ].map((x) => x.raster_key)
                "
                @post_calc="
                  active_file_key = null;
                  dai_val = null;
                  refreshAvailabelData('promedio_sada', 'promedio', true);
                  clean_data_selected_point();
                "
                @close="showMeanModal = false"
              >
              </ModalMeanSADA>
            </td>
            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                style="width: 100%"
                @click="showCorrModal = true"
              >
                Mapa de correlación
              </button>
              <ModalCorrSADA
                v-if="showCorrModal"
                :waiting.sync="waiting"
                :waiting_msg.sync="waiting_msg"
                :current_map_special_name.sync="current_map_special_name"
                v-bind:options="
                  this.available_datasets['SADA']['raster_data'][
                    'order_keys'
                  ].map((x) => x.raster_key)
                "
                @post_calc="
                  active_file_key = null;
                  dai_val = null;
                  refreshAvailabelData('CORR_sada', 'correlacion', true);
                  clean_data_selected_point();
                "
                @close="showCorrModal = false"
              >
              </ModalCorrSADA>
            </td>
          </tr>
          <tr>
            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                style="width: 100%"
                @click="reset_to_SADA"
              >
                Limpiar
              </button>
            </td>
          </tr>
        </table>
        <hr />

        <div class="row" style="margin-left: 1px">
          <h3 class="title_nav">Patrones por regiones</h3>
          <button
            @click="$vm2.open('modal-2')"
            class="button_as_link"
            style="width: 40px; margin-left: 10px; margin-bottom: 2px"
          >
            <v-icon
              style="width: 25px; margin-bottom: 4px"
              name="help-circle"
            ></v-icon>
          </button>
          <vue-modal-2
            name="modal-2"
            @on-close="$vm2.close('modal-2')"
            :noFooter="true"
            :headerOptions="{ title: 'Ayuda' }"
          >
            Permite calcular series de tiempo anuales para un territorio
            seleccionado de:
            <ul>
              <li>
                (i) su promedio del Indice de Severidad de Sequía de Palmer
                (PDSI)
              </li>
              <li>
                (ii) el porcentaje de su territorio a escala anual que se vio
                afectado por sequía.
              </li>
            </ul>

            Los (i) y (ii) pueden calcularse para toda la región de estudio del
            Atlas de Sudamérica, o para una región de interés del usuario que
            puede ser indicada por un área que se dibuje, un área que se “suba”
            como kmz o kml, o un área dada por las regiones administrativas de
            Chile y provincias de Argentina
          </vue-modal-2>
        </div>
        <table style="table-layout: fixed; width: 100%">
          <tr>
            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                @click="showShapeModal = true"
                style="width: 100%"
              >
                Suba su región
              </button>

              <ModalShapeSADA
                v-if="showShapeModal"
                :key_file_current.sync="active_file_key"
                @close="showShapeModal = false"
                @reset_sada="reset_to_SADA()"
              >
              </ModalShapeSADA>
            </td>
            <td style="width: 50%">
              <button
                type="button"
                @click="log_t"
                class="btn btn-secondary button_rows"
                style="width: 100%"
              >
                Dibuje su región
              </button>
            </td>
          </tr>
          <tr>
            <td style="width: 50%">
              <button
                type="button"
                @click="calc_regiones"
                class="btn btn-secondary button_rows"
                style="width: 100%"
              >
                Regiones administrativas
              </button>
            </td>

            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                style="width: 100%"
                @click="reset_to_SADA"
              >
                Limpiar
              </button>
            </td>
          </tr>
          <tr>
            <td style="width: 50%">
              <button
                @click="showdaiModal = true"
                class="btn btn-secondary button_rows"
                type="button"
                style="width: 100%"
              >
                {{ active_file_key ? "% área bajo sequía dado región" : "% área bajo sequía Sudamérica" }}
              </button>
              <ModalDAI
                :waiting.sync="waiting"
                :waiting_msg.sync="waiting_msg"
                :dai_val.sync="dai_val"
                @recalc_dai="recalc_dai()"
                v-if="showdaiModal"
                @close="showdaiModal = false"
              >
              </ModalDAI>
            </td>
          </tr>
        </table>

        <hr />
        <div class="row" style="margin-left: 1px">
          <h3 class="title_nav">Exportar mapas y series</h3>
          <button
            @click="$vm2.open('modal-3')"
            class="button_as_link"
            style="width: 40px; margin-left: 10px; margin-bottom: 2px"
            title=""
          >
            <v-icon
              style="width: 25px; margin-bottom: 4px"
              name="help-circle"
            ></v-icon>
          </button>

          <vue-modal-2
            name="modal-3"
            @on-close="$vm2.close('modal-3')"
            :noFooter="true"
            :headerOptions="{ title: 'Ayuda' }"
          >
            Permite “bajar” el mapa desarrollado como figura en formato png y
            como datos numéricos en formato nc, y también permite bajar la serie
            de tiempo que se visualiza en el gráfico.
          </vue-modal-2>
        </div>
        <table style="table-layout: fixed; width: 100%">
          <tr>
            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                @click="
                  download_current_raster(
                    '/export_to_netcdf/DATA_SET/RASTER_ACTIVE',
                    'nc'
                  )
                "
                style="width: 100%"
              >
                Mapa como datos
              </button>
            </td>
            <td style="width: 50%">
              <button
                type="button"
                class="btn btn-secondary button_rows"
                @click="
                  download_current_raster(
                    '/export_to_png/DATA_SET/RASTER_ACTIVE',
                    'png'
                  )
                "
                style="width: 100%"
              >
                Mapa como figura
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                @click="export_data_to_csv"
                class="btn btn-secondary button_rows"
                type="button"
                style="width: 100%"
              >
                Serie de tiempo gráfico
              </button>
            </td>
          </tr>
        </table>

        <hr />

        <div class="row" style="margin-left: 1px">
          <h3 class="title_nav">Escala</h3>

          <button
            @click="$vm2.open('modal-4')"
            class="button_as_link"
            style="width: 40px; margin-left: 10px; margin-bottom: 2px"
            title=""
          >
            <v-icon
              style="width: 25px; margin-bottom: 4px"
              name="help-circle"
            ></v-icon>
          </button>

          <vue-modal-2
            name="modal-4"
            @on-close="$vm2.close('modal-4')"
            :noFooter="true"
            :headerOptions="{ title: 'Ayuda' }"
          >
            Permite elegir distintos tonos par la escala de colores del mapa de
            PDSI, y también cambiar su límite de valor de PDSI superior e
            inferior (por defecto 4 y -4).
          </vue-modal-2>
        </div>

        <table style="table-layout: fixed; width: 100%; text-align: left">
          <tr>
            <td style="width: 50%">
              <p>Color</p>
            </td>
            <td style="width: 50%">
              <select
                class="custom-select"
                v-model="current_colormap"
                name="colormap"
              >
                <option
                  v-for="(val, key) in available_colormaps['colormaps']"
                  :key="key"
                >
                  {{ val }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td style="width: 50%">
              <p>Valor mínimo:</p>
            </td>
            <td style="width: 50%">
              <vue-slider
                v-model="min_val_colormap"
                :width="100"
                :min="-10"
                :max="+10"
                :lazy="true"
                :interval="0.2"
              ></vue-slider>
            </td>
          </tr>
          <tr>
            <td style="width: 50%">
              <p>Valor máximo:</p>
            </td>
            <td style="width: 50%">
              <vue-slider
                v-model="max_val_colormap"
                :width="100"
                :min="-10"
                :max="+10"
                :lazy="true"
                :interval="0.2"
              ></vue-slider>
            </td>
          </tr>
        </table>
      </div>

      <hr />
      <h3 class="title_nav">Colaboran</h3>

      <table>
        <tr>
          <td>
            <img
              :src="require('@/assets/ELdZ_ml_cmyk_en.jpg')"
              style="width: 120px; height: 70px"
            />
          </td>
          <td>
            <img
              :src="require('@/assets/gizlogo-unternehmen-de-rgb-300.jpg')"
              style="width: 120px; height: 70px"
            />
          </td>
          <td>
            <img
              :src="require('@/assets/logo_ianigla.jpg')"
              style="width: 120px; height: 70px"
            />
          </td>
        </tr>
      </table>
      <p
        class="help-block"
        style="font-size: 75%; color: black; text-align: justify"
      >
        Apoyado por el Programa Mundial de Evaluación y Gestión de Riesgos para
        la Adaptación al Cambio Climático (Pérdidas y Daños) por encargo del
        Ministerio Federal de Cooperación Económica y Desarrollo (BMZ)
      </p>

      <hr />
      <h3 class="title_nav">Fuente</h3>

      <span
        class="help-block"
        style="font-size: 75%; color: black; text-align: justify"
      >
        <a href="http://www.cr2.cl/datos-dendro-sada/" target="_blank">
          Six hundred years of South American tree rings reveal an increase in
          severe hydroclimatic events since mid-20th century. Proceedings of the
          National Academy of Sciences (2020)
        </a>

        <p style="margin-top: 5px">
          Entre los años 1400-2000 se utilizan los datos de
          <a target="_blank" href="https://www.pnas.org/content/117/29/16816"
            >scPDSI de Morales et al. (2020) en base a anillos de árboles</a
          >, a partir del 2001 se actualiza con los datos de
          <a
            target="_blank"
            href="https://crudata.uea.ac.uk/cru/data/drought/#global"
            >scPDSI del CRU en base a registros instrumentales</a
          >
          de acuerdo a
          <a
            target="_blank"
            href="https://science.sciencemag.org/content/306/5698/1015"
            >Cook et al. (2004)</a
          >, reescalando los datos de Morales et al. (2020) de forma que durante
          el periodo de calibración 1951-2000 su varianza sea la misma que la de
          los datos del
          <a
            target="_blank"
            href="https://crudata.uea.ac.uk/cru/data/drought/#global"
            >CRU</a
          >
        </p>
      </span>
      <p
        class="help-block"
        style="font-size: 75%; color: black; text-align: justify"
      >
        Esta plataforma web ha sido desarrollada por: Andrés Ferrada, Duncan A.
        Christie, Francisca Muñoz, Alvaro González, René D. Garreaud & Susana
        Bustos (2021) Explorador del Atlas de Sequías de Sudamérica,
        <a href="https://sada.cr2.cl">https://sada.cr2.cl</a>. Centro de Ciencia
        del Clima y la Resiliencia (CR)<sup>2</sup>.
        <a href="https://doi.org/10.13140/RG.2.2.14020.35209"
          >doi.org/10.13140/RG.2.2.14020.35209l</a
        >
      </p>
      <p
        class="help-block"
        style="font-size: 75%; color: black; text-align: justify"
      >
        Contacto:
        <a href="mailto:duncanchristieb@gmail.com">duncanchristieb@gmail.com</a>
      </p>
    </div>

    <div id="vals_ref" style="display: flex; border-radius: 12px">
      <table style="margin-left: 5px">
        <thead style="background-color: white; color: black; font-weight: 700">
          <tr>
            <th colspan="2" style="padding-bottom: 6px">
              Escala del Indice de Sequía de Palmer (PDSI)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>4 o más:</td>
            <td>Extremadamente húmedo</td>
          </tr>
          <tr>
            <td>3.0 a 3.9:</td>
            <td>Muy húmedo</td>
          </tr>
          <tr>
            <td>2.0 a 2.9:</td>
            <td>Moderadamente Húmedo</td>
          </tr>
          <tr>
            <td>1.0 a 1.9:</td>
            <td>Ligeramente húmedo</td>
          </tr>
          <tr>
            <td>0.5 a 0.9:</td>
            <td>Incipientemente húmedo</td>
          </tr>
          <tr>
            <td>-0.49 a 0.49:</td>
            <td>Normal</td>
          </tr>
          <tr>
            <td>-0.9 a -0.5:</td>
            <td>Sequía incipiente</td>
          </tr>
          <tr>
            <td>-1.9 a -1.0:</td>
            <td>Sequía suave</td>
          </tr>
          <tr>
            <td>-2.9 a -2.0:</td>
            <td>Sequía moderada</td>
          </tr>
          <tr>
            <td>-3.9 a -3.0:</td>
            <td>Sequía severa</td>
          </tr>
          <tr>
            <td>-4 o menos:</td>
            <td>Sequía extrema</td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div>
        <img id="colorbar_image" :src="computed_colormap_url" />
      </div>
    </div>

    <div class="col-sm-9" style="margin-left: 21%">
      <div>
        <a href="http://www.cr2.cl/datos-dendro-sada/">
          <img
            :src="require('@/assets/banner_sada.jpg')"
            style="width: 100%; width: 90.5%"
          />
        </a>
      </div>
    </div>

    <div
      class="col-sm-9"
      id="mapid"
      style="height: 500px; width: 100%; margin-left: 21%; margin-top: 10px"
    >
      <l-map
        ref="map"
        id="mapid"
        :maxZoom="7"
        :minZoom="2"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @click="getMapvalue"
      >
        <div
          class="col-sm-9"
          style="
            justify-content: space-between;
            display: flex;
            top: 390px;
            right: 0;
            position: absolute;
            z-index: 450;
            width: 100px;
          "
        >
          <a href="/" style="width: 150px; text-align: center">
            <img :src="require('@/assets/refresh.png')" />
          </a>
        </div>

        <l-rectangle
          :bounds="rec_bounds"
          :l-style="{ color: 'red', weight: 3 }"
        ></l-rectangle>

        <l-marker
          v-bind:key="key"
          v-for="(marker, key) in markers"
          :lat-lng="marker"
          :icon="icon"
        ></l-marker>
        <l-tile-layer :url="url" :attribution="attribution" transparent: true />

        <l-image-overlay
          ref="image_layer"
          :bounds="bounds"
          :opacity="0.5"
          :interactive="true"
          :url="computed_img_url"
        ></l-image-overlay>

        <div v-if="geojson !== null">
          <l-geo-json
            v-bind:key="key"
            v-for="(gf, key) in geojson['features']"
            :options="options_geojson(gf)"
            :geojson="gf"
            :options-style="styleFunction(gf)"
            ref="key"
          ></l-geo-json>
        </div>
      </l-map>
    </div>

    <div class="col-sm-9" style="margin-left: 21%">
      <h4>
        {{ this.computed_map_name }}
      </h4>

      <Plotly
        :data="data_test"
        :layout="plot_layout"
        :modeBarButtonsToRemove="['resetScale2d']"
        :displayModeBar="true"
      ></Plotly>
    </div>

    <DrawComponent
      :draw_mode.sync="draw_mode"
      :key_file_current.sync="active_file_key"
      :current_map_object="this.current_map_object"
      @reset_sada="reset_to_SADA()"
    ></DrawComponent>
  </div>
</template>

<script>
import { DomEvent, latLng, latLngBounds, divIcon } from "leaflet";
import {
  LMap,
  LRectangle,
  LTileLayer,
  LImageOverlay,
  LGeoJson,
  LMarker,
} from "vue2-leaflet";

import { Icon } from "leaflet";
import VueSlider from "vue-slider-component";
import { Plotly } from "vue-plotly";
import ModalMeanSADA from "@/components/modal_mean.vue";
import ModalShapeSADA from "@/components/modal_shape.vue";
import ModalCorrSADA from "@/components/modal_corr.vue";
import ModalDAI from "@/components/modal_dai.vue";

import "../../node_modules/leaflet-draw/dist/leaflet.draw.css";
import DrawComponent from "@/components/draw_geometry.vue";

import "vue-slider-component/theme/default.css";
import Spinner from "vue-simple-spinner";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const plot_layout_sada = {
  margin: { l: 30, r: 30, t: 50, b: 50 },
  height: 300,
  yaxis: {
    range: [-5, +5],
    title: { text: "PDSI", font: { size: 18 } },
    tickfont: { size: 16 },
  },
  xaxis: {
    title: { text: "Años", font: { size: 18 } },
    range: [1390, 2040],
    tickfont: { size: 16 },
  },
  showgrid: true,
};
const plot_layout_dai = {
  margin: { l: 40, r: 30, t: 50, b: 50 },
  height: 300,
  yaxis: {
    range: [0, 100],
    title: { text: "% área bajo sequía", font: { size: 18 } },
    tickfont: { size: 16 },
  },
  xaxis: {
    title: { text: "Años", font: { size: 18 } },
    range: [1390, 2040],
    tickfont: { size: 16 },
  },

  showgrid: true,
};
const no_data_layout = {
  margin: { l: 40, r: 30, t: 50, b: 50 },
  height: 300,
  xaxis: {
    title: { text: "Años", font: { size: 18 } },
    range: [1390, 2040],
    tickfont: { size: 16 },
  },
  yaxis: { visible: true, range: [0, +4], tickfont: { size: 16 } },
  annotations: [
    {
      text:
        "Seleccionar pixeles en mapa o sección Patrones por regiones para ver series de tiempo",
      xref: "paper",
      yref: "paper",
      showarrow: false,
      font: {
        size: 25,
      },
    },
  ],
};

const CONST_DATASETS = "SADA";

const myCustomColour = "#FF1919";
const markerHtmlStyles = `
  background-color: ${myCustomColour};
  width: 2rem;
  height: 2rem;
  display: block;
  left: -1.5rem;
  top: -1.5rem;
  position: relative;
  border-radius: 3rem 3rem 0;
  transform: rotate(45deg);
  border: 1px solid #FFFFFF`;

export default {
  name: "Example",
  components: {
    DrawComponent,
    LMarker,
    LRectangle,
    Spinner,
    LMap,
    ModalCorrSADA,
    ModalShapeSADA,
    ModalDAI,
    ModalMeanSADA,
    LTileLayer,
    VueSlider,
    Plotly,
    LImageOverlay,
    LGeoJson,
  },
  mounted() {
    this.$nextTick(() => {
      let map = this.$refs.map.mapObject;
      this.current_map_object = map;

      this.calc_internal_cmap();
    });

    this.refreshAvailabelData();
  },

  watch: {
    geojson_status: function (newGeojsonStatus) {
      this.update_geojson_shape(newGeojsonStatus).then((new_geojson) => {
        this.click_in_geojson = true;
        
        // en lo posible intenta usar la ultima geometria seleccionada. Si no es posible default primera geometria disponible.
        let selected_geojson = (this.current_geometry_index < new_geojson["features"].length ) ? (new_geojson["features"][this.current_geometry_index]) : new_geojson["features"][0]
        
        this.update_time_series_data(selected_geojson);
      });
    },
    computed_colormap_url: function () {
      this.calc_internal_cmap();
    },
  },

  data() {
    return {
      current_geometry_index: 0,

      dai_global: false,
      val_units: "PDSI",

      rec_bounds: [
        [0, 10],
        [0, 10],
      ],
      icon: divIcon({
        className: "my-custom-pin",
        iconAnchor: [-9, 18],
        labelAnchor: [-6, 30],
        popupAnchor: [0, -36],
        html: `<span style="${markerHtmlStyles}" />`,
      }),
      markers: [],

      current_map_special_name: null,

      plot_layout: no_data_layout,

      current_geojson_cmap: null,

      click_in_geojson: false,

      dai_val: null,
      current_map_object: null,
      draw_mode: false,
      waiting: false,
      waiting_msg: "Cargando shape",

      active_file_key: null,

      showMeanModal: false,
      showCorrModal: false,
      showShapeModal: false,
      showdaiModal: false,

      available_datasets: [],
      available_rasters: [],
      available_keys_order_rasters: [],
      active_dataset: "SADA",
      active_raster: "1400",

      available_colormaps: { colormaps: ["Arcoiris"] },
      current_colormap: "Arcoiris",
      min_val_colormap: -4,
      max_val_colormap: 4,

      zoom: 3,
      url_image: "./simple_img/DATASET_KEY/RASTER_KEY/LAT_A/LON_A/LAT_B/LON_B",
      center: latLng(-35.31, -74.8),

      bound_map: {},

      bounds: latLngBounds(
        latLng(-100.496472765758952, -24.697265625000004),
        latLng(-55.128649068488784, -112.14843750000001)
      ),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      data_test: [],
      sel_lat_lon: {},
      geojson: null,
    };
  },
  async created() {
    let response = await fetch("/available_colormaps");
    this.available_colormaps = await response.json();
  },
  computed: {
    computed_map_name: function () {
      let mapa_name = { correlacion: "Correlación", promedio: "Promedio" };
      let string_name =
        this.active_raster in mapa_name
          ? mapa_name[this.active_raster]
          : "Atlas";

      let extra_name = this.current_map_special_name
        ? '"' + this.current_map_special_name + '"'
        : "";

      let current_sel =
        (this.active_raster == "correlacion") |
        (this.active_raster == "promedio")
          ? ""
          : `Año: ${this.active_raster}`;

      return `Mapa: ${string_name} ${current_sel}  ${extra_name}`;
    },

    geojson_status: function () {
      return {
        active_dataset: CONST_DATASETS,
        active_file_key: this.active_file_key,
      };
    },
    computed_colormap_url() {
      return `./colobar/${this.current_colormap}/${this.max_val_colormap}/${this.min_val_colormap}?val_units=${this.val_units}`;
    },
    computed_img_url: function () {
      let info_raster_dataset = this.get_raster_dataset(
        this.active_dataset,
        this.active_raster
      );
      let fixed_raster = info_raster_dataset.raster;
      let fixed_dataset = info_raster_dataset.dataset;

      let temp = {
        // Cuando se reajusta el mapa se recalcula url de imagen
        lat_a: this.bounds._southWest.lat,
        lon_a: this.bounds._southWest.lng,
        lat_b: this.bounds._northEast.lat,
        lon_b: this.bounds._northEast.lng,
      };
      let url_test = this.url_image
        .replace("RASTER_KEY", fixed_raster)
        .replace("DATASET_KEY", fixed_dataset)
        .replace("LAT_A", temp["lat_a"])
        .replace("LAT_B", temp["lat_b"])
        .replace("LON_A", temp["lon_a"])
        .replace("LON_B", temp["lon_b"]);

      let current_t = Date.now(); // truco para evitar cache de imagenes (de mantener la misma url puede devolver data antigua cacheadaa)

      url_test =
        url_test +
        `?colormap=${this.current_colormap}&max_val=${this.max_val_colormap}&min_val=${this.min_val_colormap}&t=${current_t}`;

      return url_test;
    },
  },
  methods: {
    reset_to_SADA() {
      this.refreshAvailabelData("SADA", "1400", false);
      this.geojson = null;
      this.plot_layout = no_data_layout;
      this.data_test = [];
      this.active_file_key = null;
      this.compose_key = null;
      this.val_units = "PDSI";
      this.max_val_colormap = 4;
      this.min_val_colormap = -4;
      this.dai_val = null;
      this.dai_global = false;

      this.markers = [];
      this.rec_bounds = [
        [0, 10],
        [0, 10],
      ];
    },
    recalc_dai() {
      if (this.active_file_key == null) {
        let url = `/global_DAI/${this.dai_val}`;

        if (this.dai_val) {
          this.axios.get(url).then((response) => {
            // colocar serie de tiempo que retorna
            this.data_test = [response.data];
            // Colocar en nombre especial DAI todo el atlas.
            this.current_map_special_name = "% área con sequía Atlas completo";
            this.plot_layout = plot_layout_dai;
            this.dai_global = true;

            this.markers = [];
            this.rec_bounds = [
              [0, 10],
              [0, 10],
            ];
          });
        }
      } else {
        this.update_geojson_shape(this.geojson_status).then((new_geojson) => {
          this.markers = [];
          this.rec_bounds = [
            [0, 10],
            [0, 10],
          ];
          this.click_in_geojson = true;

        // en lo posible intenta usar la ultima geometria seleccionada. Si no es posible default primera geometria disponible.
        let selected_geojson = (this.current_geometry_index < new_geojson["features"].length ) ? (new_geojson["features"][this.current_geometry_index]) : new_geojson["features"][0]
        this.update_time_series_data(selected_geojson);
        });
      }
    },
    calc_internal_cmap() {
      let cmap_url = `./get_colormap/${this.current_colormap}/${this.min_val_colormap}/${this.max_val_colormap}/250`;
      this.axios.get(cmap_url, { withCredentials: true }).then((response) => {
        this.current_geojson_cmap = response.data;
      });
    },

    calc_color(x) {
      let arr = this.current_geojson_cmap["color_scale"];
      let start = 0,
        end = arr.length - 1;
      while (start <= end) {
        let mid = Math.floor((start + end) / 2);
        if (arr[mid] === x) return start;
        else if (arr[mid] < x) start = mid + 1;
        else end = mid - 1;
      }

      start = Math.min(Math.max(start, 0), arr.length - 1);
      let out_color = this.current_geojson_cmap["colors"][start];
      return out_color;
    },

    export_data_to_csv() {
      let to_send = this.data_test.filter((x) => x.visible);

      if (to_send[0]) {
        let ext = "xlsx";

        this.axios
          .post(
            "./generate_excel",
            { plot: to_send },
            { withCredentials: true, responseType: "blob" }
          )
          .then((response) => {
            const url = window.URL.createObjectURL(
              new Blob([response.data], { type: "application/vnd.ms-excel" })
            );
            const link = document.createElement("a");
            const now = new Date().toLocaleString();
            link.href = url;
            const name_out = `Data_${this.active_dataset}_${this.active_raster}_${now}.${ext}`;
            link.setAttribute("download", name_out);
            document.body.appendChild(link);
            link.click();
          });
      } else {
        alert("No hay series de tiempo en selección. Hacer click en mapa. ");
      }
    },
    update_geojson_shape(geojsonStatus) {
      let newFileKey = geojsonStatus.active_file_key;

      let myFirstPromise = new Promise((resolve, reject) => {
        if (newFileKey) {
          this.waiting_msg = "Cargando shape";
          this.waiting = true;
          let url_end = `./get_regions/${newFileKey}`;

          this.axios
            .get(url_end, { withCredentials: true })
            .then((resp_end) => {
              this.geojson = resp_end.data;
              this.waiting = false;
              this.waiting_msg = "";
              this.refreshAvailabelData("SADA", "1400", false); // asegurarse que se este en SADA para regiones
              resolve(resp_end.data);
            })
            .catch((error) => {
              this.waiting = false;
              this.waiting_msg = "";
              alert(error);
              reject("Fail");
            });
        } else {
          this.geojson = null;
        }
      });

      return myFirstPromise;
    },

    onEachFeatureFunction(gf) {
      return (feature, layer) => {
        layer.on({
          click: (x) => {
            // apaga todos los geojsons
            for (let y of this.geojson["features"]) {
              y["properties"]["fillOpacity"] = 0;
            }
            // prende solo la seleccion actual
            gf["properties"]["fillOpacity"] = 1;
            this.query_geojson_data(x, gf);
          },
        });
      };
    },

    options_geojson(gf) {
      return {
        onEachFeature: this.onEachFeatureFunction(gf),
      };
    },
    calc_regiones() {
      // volver primero a fuente sada
      this.reset_to_SADA();
      this.active_file_key = "REGIONS";
    },
    styleFunction(geojson) {
      let current_color = "#ECEFF1";
      let current_val = -1;
      let fillOp = 0;

      if (geojson) {
        if (geojson["properties"]["current_val"]) {
          current_val = geojson["properties"]["current_val"];
          current_color = this.calc_color(current_val);
          fillOp = geojson["properties"]["fillOpacity"]
            ? geojson["properties"]["fillOpacity"]
            : 0;
        } else {
          fillOp = 0;
        }
      }
      return () => {
        return {
          weight: 2,
          color: "black",
          opacity: 0.3,
          fillColor: current_color,
          fillOpacity: fillOp, // 1
        };
      };
    },

    log_t() {
      this.draw_mode = !this.draw_mode;
    },

    get_raster_dataset(dataset, raster) {
      let t = String(raster);
      if (this.available_keys_order_rasters.includes(t)) {
        return { raster: t, dataset: "SADA" };
      } else {
        return { raster: t, dataset: dataset };
      }
    },

    download_current_raster(base_url, ext) {
      let units = this.active_raster == "correlacion" ? "Correlación" : "PDSI";

      let info_raster_dataset = this.get_raster_dataset(
        this.active_dataset,
        this.active_raster
      );
      let fixed_raster = info_raster_dataset.raster;
      let fixed_dataset = info_raster_dataset.dataset;

      let current_t = Date.now(); // truco para evitar cache de imágenes (de mantener la misma url puede devolver data antigua cacheada)

      let download_url =
        base_url
          .replace("RASTER_ACTIVE", fixed_raster)
          .replace("DATA_SET", fixed_dataset) +
        `?colormap=${this.current_colormap}&max_val=${this.max_val_colormap}&min_val=${this.min_val_colormap}&title=${this.computed_map_name}&units=${units}&t=${current_t}`;

      this.axios
        .get(download_url, { withCredentials: true, responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          const now = new Date().toLocaleString();
          link.href = url;
          const name_out = `Data_${this.active_dataset}_${this.active_raster}_${now}.${ext}`;
          link.setAttribute("download", name_out);
          document.body.appendChild(link);
          link.click();
        });
    },

    change_scale_to_correlation() {
      this.max_val_colormap = 1;
      this.min_val_colormap = -1;
      this.val_units = "R";
    },
    change_scale_to_PDSI() {
      this.max_val_colormap = 4;
      this.min_val_colormap = -4;
      this.val_units = "PDSI";
    },
    onChangeRaster() {
      if (this.val_units == "R" && this.active_raster != "correlacion") {
        this.change_scale_to_PDSI();
      }
      this.dai_val = null;
      this.current_map_special_name = null;
      this.clean_data_selected_point();
    },
    refreshAvailabelData(dataset_to_set, raster_to_set, use_special_name) {
      let url = "./available_datasets";

      if (!use_special_name) {
        this.current_map_special_name = null;
      }

      let default_key = "SADA";
      if (dataset_to_set) {
        default_key = dataset_to_set;
      }

      this.axios.get(url, { withCredentials: true }).then((response) => {
        if (response.data.available_datasets) {
          let temp = {};
          for (let k in response.data.available_datasets) {
            temp[k] = response.data.available_datasets[k]["bounds"];
          }
          this.bound_map = temp;

          this.available_datasets = response.data.available_datasets;

          if (!(default_key in this.available_datasets)) {
            return;
          }

          let r_data = this.available_datasets[default_key]["raster_data"];
          let sada_maps = this.available_datasets["SADA"]["raster_data"][
            "order_keys"
          ];

          if (raster_to_set == "correlacion") {
            this.available_rasters = r_data["extra_keys"]; // Caso especial Correlacion no permite ir a mapa normales
            this.change_scale_to_correlation();
          } else if (raster_to_set == "promedio") {
            this.available_rasters = r_data["extra_keys"]; // Caso especial Correlacion no permite ir a mapa normales
            this.change_scale_to_PDSI();
          } else {
            this.available_rasters = sada_maps.concat(r_data["extra_keys"]);
            this.change_scale_to_PDSI();
          }

          this.available_keys_order_rasters = sada_maps.map(
            (y) => y.raster_key
          );

          this.active_raster = sada_maps[0]["raster_key"];
          this.active_dataset = this.available_datasets[default_key][
            "key_dataset"
          ];

          // bounds de imagen
          let t = this.bound_map[this.active_dataset];
          this.bounds = new latLngBounds(
            new latLng(t.yf, t.xf),
            new latLng(t.y0, t.x0)
          );

          if (raster_to_set) {
            this.active_raster = raster_to_set;
          }
        }
      });
    },

    update_time_series_data(current_geojson) {
      this.current_geometry_index = current_geojson["properties"].array_index;

      let region_id = current_geojson["properties"]["geometry_id"];
      let vars_to_calc = ["PDSI", "spline"];

      let dai_key = null;
      if (this.dai_val) {
        let val_to_use = Number(this.dai_val).toFixed(3);
        dai_key = `dai_${val_to_use}`;
        vars_to_calc.push(dai_key);
      }

      this.axios
        .post(
          "./get_time_series",
          {
            variables: vars_to_calc,
            region_id: region_id,
            dataset_id: "SADA",
          },
          { withCredentials: true }
        )
        .then((response) => {
          let res = response.data;

          let sel_series = res["PDSI"];
          let spline_series = res["spline"];

          let serie_dai = null;
          if (dai_key) {
            serie_dai = res[dai_key];
          }

          // pega el valor actual para colores fill
          let val_current = null;
          let i = 0;
          for (let t of sel_series["x"]) {
            if (t == this.active_raster) {
              val_current = sel_series["y"][i];
            }
            i = i + 1;
          }
          if (val_current) {
            current_geojson.properties["current_val"] = val_current;
            current_geojson.properties["fillOpacity"] = 1;
          }

          let geometry_name = current_geojson.properties["NAME_1"];
          this.current_map_special_name = geometry_name;

          // Esto itera todas las geometrías y se queda con la mayor cantidad de puntos.
          let sel = null;
          let n = 0;
          for (let t of current_geojson.geometry.coordinates) {
            if (t) {
              let shape_inside = t[0].length;

              if (shape_inside != 3 && shape_inside != 2) {
                t = t[0];
              }
              if (t.length > n) {
                n = t.length;
                sel = t;
              }
            }
          }

          if (sel) {
            let xs = sel.map((x) => x[0]).reduce((x, y) => x + y, 0);
            let ys = sel.map((x) => x[1]).reduce((x, y) => x + y, 0);

            xs = xs / n;
            ys = ys / n;

            this.sel_lat_lon = { lat: xs, lon: ys, geojson: "Serie geojson" };
            this.markers = [latLng(ys, xs)];
            this.rec_bounds = [
              [0, 10],
              [0, 10],
            ];

            this.data_test = [sel_series, spline_series];

            if (serie_dai) {
              this.data_test.push(serie_dai);
            }

            if (this.dai_val && this.click_in_geojson) {
              this.plot_layout = plot_layout_dai;

              for (let t of this.data_test) {
                if (t.name.includes("sequ")) {
                  t["visible"] = true;
                } else {
                  t["visible"] = false;
                }
              }
            } else {
              // normal plot layout
              this.plot_layout = plot_layout_sada;
            }
          }
        });
    },
    query_geojson_data(event, current_geojson) {
      this.rec_bounds = [
        [0, 10],
        [0, 10],
      ];

      if (current_geojson) {
        this.click_in_geojson = true;
        this.update_time_series_data(current_geojson);

        // detener evento de seguir propagandose. De lo contrario tambie lee el mapa debajo
        DomEvent.stopPropagation(event);
        event.originalEvent.stopImmediatePropagation();
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
      }
    },

    clean_data_selected_point() {
      if (this.geojson) {
        for (let y of this.geojson["features"]) {
          y["properties"]["fillOpacity"] = 0;
        }
      }

      this.dai_global = false;
      this.data_test = [];
      this.plot_layout = no_data_layout;
      this.sel_lat_lon = { lat: null, lon: null };
      this.markers = [];
      this.rec_bounds = [
        [0, 10],
        [0, 10],
      ];
    },
    getMapvalue(x) {
      if (this.dai_global) {
        alert(
          "El cálculo de sequía sin región calcula sequía para toda Sudamérica.\nPor lo tanto no hay serie de tiempo asociada por pixel.\n\nPara salir de este modo presionar en alguna otra opción de 'Patrones por regiones', 'Mapas' o el botón 'Limpiar'. "
        );
        return;
      }
      if (this.geojson) {
        for (let y of this.geojson["features"]) {
          y["properties"]["fillOpacity"] = 0;
        }
      }

      if (this.dai_global || this.click_in_geojson) {
        if (
          this.active_raster != "correlacion" &&
          this.active_raster != "promedio"
        ) {
          this.current_map_special_name = null;
        }
      }

      this.click_in_geojson = false;
      let latlngObj = x.latlng;

      let info_raster_dataset = this.get_raster_dataset(
        this.active_dataset,
        this.active_raster
      );
      let fixed_raster = info_raster_dataset.raster;
      let fixed_dataset = info_raster_dataset.dataset;

      let url =
        "./describe/DATASET_KEY/RASTER_KEY/"
          .replace("RASTER_KEY", fixed_raster)
          .replace("DATASET_KEY", fixed_dataset) +
        latlngObj.lat +
        "/" +
        latlngObj.lng;

      this.axios.get(url).then((response) => {
        let ret_raster = response.data.near_raster;
        if (ret_raster) {
          this.sel_lat_lon = { lat: ret_raster.n_lat, lon: ret_raster.n_lon };

          // Para posicionar el marker se toma como referencia el pixel_raster seleccionado (esquina superior izq)
          // y se lo desfasa para que quede mejor visualmente
          let lat_ajuste_visual = ret_raster.n_lat - 0.125;
          let lon_ajuste_visual = ret_raster.n_lon;
          this.markers = [latLng(lat_ajuste_visual, lon_ajuste_visual)];

          // colocar highlight
          let croped_x = ret_raster.n_lat;
          let croped_y = ret_raster.n_lon;
          var bounds = [
            [croped_x - 0.25, croped_y - 0.25],
            [croped_x + 0.25, croped_y + 0.25],
          ];
          this.rec_bounds = bounds;
        }
      });

      url =
        "./time_series/DATASET_KEY/".replace("DATASET_KEY", CONST_DATASETS) +
        latlngObj.lat +
        "/" +
        latlngObj.lng;
      this.axios.get(url).then((response) => {
        if (response.data.time_series) {
          this.data_test = response.data.time_series;
          this.plot_layout = plot_layout_sada;
        } else {
          this.clean_data_selected_point();
        }
      });
    },
  },
};
</script>

<style scoped>
.waiting_div {
  height: 60px;
  width: 200px;
  position: absolute;
  top: 10;
  background: white;
  right: 15%;
  z-index: 1;
  border-radius: 5px;
  margin-top: 10px;
}

.plot_info {
  margin-top: 10px;
  font-size: small;
}

.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #737373;
}

.time_series_button {
  font-size: small;
}

.button_rows {
  height: 60px;
  width: 95px;
  overflow: hidden;
  display: block;
  background-color: #955634;
  text-overflow: ellipsis;
  font-size: 14px;
}

#vals_ref {
  position: absolute;
  z-index: 450;
  left: 22%;
  top: 220px;
  font-size: 11pt;
  width: 415px;
  background-color: white;
  text-align: left;
}

#colorbar_image {
  z-index: 450;
  margin-left: 0px;
  width: 85px;
  margin-top: 50%;
}

.button_as_link {
  background: none !important;
  border: none;
  padding: 0 !important;
  /*optional*/
  font-family: arial, sans-serif;
  /*input has OS specific font-family*/
  color: #069;
  text-decoration: underline;
  cursor: pointer;
}

.title_nav {
  text-align: left;
  font-size: 1.2rem;
}

.icon {
  width: 24px;
}

#nav_options {
  background-color: #c19d8a85;
  padding-top: 16px;
  position: absolute;
  top: 0;
  box-shadow: 0 0 16px 0 #333;
  transition: all 0.5s;
  width: 20% !important;
  left: 0;
  z-index: 500;
  height: 100%;
  overflow-y: auto;
}

#mapid {
  height: 100%;
  width: 100%;
}
</style>
